/**
 * @GestionalePD Admin organization page UI
 */
import { Helmet } from 'react-helmet-async';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { Navigate } from 'react-router-dom';
import { Card, Container, Grid, CardActionArea, CardMedia, CardContent, Typography } from '@mui/material';
//--------------------------------------------------------------------------------------------------------
import { HttpErrorHandler, ErrorUI } from '../../../utils/ErrorHandler';
import { EmptyPageUI, LoadingUI } from '../../../utils/LayoutStyles';
import API from '../../../api';

/**
 * @returns Admin organization page UI
 */
export default function Organization() {
  // general
  const navigate = useNavigate();
  const [organizations, setOrganizations] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);
  const [currentProfile, setCurrentProfile] = useState('');

  // get api call for entity types
  const getOrganizations = () => {
    setErrorMessage(null);

    API.get('/etypes')
      .then((response) => {
        const entityList = response.data.entity_types.filter((entity) => entity.level === 0);
        setOrganizations(entityList);
      })
      .catch((error) => HttpErrorHandler(error, setErrorMessage))
      .finally(() => setLoading(false));
  };

  // Initial entity data loading
  useEffect(() => {
    getOrganizations();
  }, []);

  // get user data
  useEffect(() => {
    let data;

    if (localStorage.getItem('userData') !== 'undefined') data = JSON.parse(localStorage.getItem('userData'));

    if (data) {
      const _currentProfile = data.roles.filter((role) => role.last_used);
      setCurrentProfile(_currentProfile);
    }
  }, []);

  if (currentProfile && currentProfile[0].prof_type_name !== 'ADMIN') return <Navigate to={{ pathname: '/' }} />;

  return (
    <div>
      <Helmet>
        <title>Organizzazione</title>
      </Helmet>

      {!isLoading ? (
        <Container maxWidth="xl">
          <Grid container direction="row" justifyContent="flex-start" alignItems="center" spacing={3}>
            {organizations.length !== 0 && !errorMessage
              ? organizations.map((organization) => (
                  <Grid
                    key={organization.id}
                    item
                    xs={12}
                    sm={6}
                    onClick={() => {
                      if (organization.level === 0) {
                        navigate('/admin/organization/federations', {
                          state: { federationID: organization.id },
                        });
                      } else {
                        navigate(`/404`);
                      }
                    }}
                  >
                    <Card sx={{ maxWidth: 'lg' }}>
                      <CardActionArea>
                        <CardMedia
                          component="img"
                          height="250"
                          image={`/assets/covers/${organization.image_path}`}
                          alt="Logo organizzazione"
                        />
                        <CardContent>
                          <Typography gutterBottom variant="h6" component="div" noWrap>
                            {organization.name}
                          </Typography>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </Grid>
                ))
              : errorMessage.length !== 0
              ? ErrorUI(errorMessage)
              : EmptyPageUI('Nessuna organizzazione trovata')}
          </Grid>
        </Container>
      ) : (
        LoadingUI()
      )}
    </div>
  );
}
